// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Y55H","productName":"Table_productName__1oIxT"};